var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import pt from 'prop-types';
import { isObject, assign, map } from 'lodash';

var List = function List(_ref) {
  var iterator = _ref.iterator,
      Component = _ref.of,
      propname = _ref.propname,
      keyname = _ref.keyname,
      rest = _objectWithoutProperties(_ref, ['iterator', 'of', 'propname', 'keyname']);

  if (iterator && Component) {
    return map(iterator, function (item, key) {
      var _assign;

      var props = assign({}, rest, (_assign = {}, _assign[propname] = item, _assign[keyname] = key, _assign));
      return React.createElement(Component, _extends({ key: key }, props));
    });
  } else {
    return 'nr-react-list Component require an "iterator" and "of" props';
  }
};
List.propTypes = process.env.NODE_ENV !== "production" ? {
  iterator: pt.oneOfType([pt.array, pt.object]).isRequired,
  of: pt.any.isRequired,
  propname: pt.string,
  keyname: pt.string
} : {};
List.defaultProps = {
  propname: 'item',
  keyname: 'idx'
};

export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/nr-react-list/es/index.js
// module id = kJ3m
// module chunks = 0